import React, { useState } from 'react'
import { ArrowDropDown } from '@mui/icons-material';

const CustomDropDown = ({ label, state, setState, onSelect, styles, valueTargetKey = "value", labelTargetKey = "label" }) => {

    const toggleOptions = param => setState(doc => ({ ...doc, visible: param === 1 ? false : !doc.visible }))

    return (
        <div className="custom-select-container" style={styles?.container}>
            {label}
            <div className="select" style={styles.select} autoFocus={true} onBlur={e => toggleOptions(1)}>
                <p
                    className={`selected ${state?.visible ? 'active' : ''}`}
                    onClick={toggleOptions}
                    style={styles?.label}
                >
                    {state?.options?.find(i => i[valueTargetKey] === state?.selected)?.[labelTargetKey] || label}
                    <ArrowDropDown />
                </p>
                {state?.visible ?
                    <div className="options" style={styles.options}>
                        {state?.options?.map(option => (
                            <div
                                className={`option ${state?.selected === option[valueTargetKey] ? 'selected-option' : ''}`}
                                onClick={e => {
                                    onSelect(option[valueTargetKey])
                                    toggleOptions(1)
                                }}
                            >{option[labelTargetKey]}
                            </div>)
                        )}
                    </div> : ''}
            </div>
        </div>
    )
}

let cursorOver = false
export const MultiSelectDropDown = ({ label, onSelect, styles, options, selected }) => {

    const toggleOptions = param => setState(doc => ({ ...doc, visible: param === 1 ? false : !doc.visible }))
    const [state, setState] = useState({ visible: false })
    const onChange = (e, option) => {
        let selectedOptions = selected?.filter(j => j.value !== option.value)
        e.target.checked && selectedOptions?.push(option)
        onSelect(selectedOptions)
    }

    return (
        <div className="custom-select-container" style={styles?.container}>
            {label}
            <button className="select" autoFocus={true} style={styles?.selectBtn} onBlur={e => !cursorOver && toggleOptions(1)} onMouseOver={e => cursorOver = true} onMouseLeave={e => cursorOver = false}>
                <p
                    className={`selected ${state?.visible ? 'active' : ''}`}
                    onClick={toggleOptions}
                    title={selected?.map(i => i.label)?.join(', ')}>
                    {selected[0]?.label || label} {selected?.length > 1 ? ` +${selected?.length - 1}` : ''}
                    <ArrowDropDown />
                </p>
                {state?.visible ?
                    <div className="options">
                        {options?.map(option => (
                            <label className="input-div" htmlFor={`checkbox:${option.value}`} style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="checkbox"
                                    name='custom_multi_selection'
                                    id={`checkbox:${option.value}`}
                                    checked={selected?.some(i => i.value === option.value)}
                                    onChange={e => onChange(e, option)} />
                                <div className="checkmark"></div>
                                {option.label}
                            </label>)
                        )}
                    </div>
                    : ''}
            </button>
        </div>
    )
}

export default CustomDropDown